module.exports = __webpack_public_path__ + "static/media/logo.8f4b6cb7.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/logo.svg
// module id = 12
// module chunks = 0